import * as Base64 from 'js-base64'

//去除首位空格
export function trimStartAndEnd(str) {
  return str.replace(/^\s+|\s+$/g, '')
}
//去除所有空格
export function trimAll(str) {
  return str.replace(/\s*/g, '')
}

//base64加密
export function Base64Encode(str) {
  return Base64.encode(str)
}

//base64加密
export function Base64Decode(str) {
  return Base64.decode(str)
}

//
export function UpNumber(obj) {
  //修复第一个字符是小数点 的情况.
  if (obj.value != '' && obj.value.substr(0, 1) == '.') {
    obj.value = ''
  }
  obj.value = obj.value.replace(/^0*(0\.|[1-9])/, '$1') //解决 粘贴不生效
  obj.value = obj.value.replace(/[^\d]/g, '') //清除“数字”和“.”以外的字符
  if (obj.value.indexOf('.') < 0 && obj.value != '') {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    if (obj.value.substr(0, 1) == '0' && obj.value.length == 2) {
      obj.value = obj.value.substr(1, obj.value.length)
    }
  }
}

/**
 *  生成UUID
 * @param withSeparator 是否有分割符
 * @returns {string}
 */
export function generateUUID(withSeparator = true) {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const tpl = withSeparator ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'
  return tpl.replace(/[xy]/g, function(c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

/**
 * 生成long uuid
 */
export function generateLongUUID(pres = 0) {
  let uniqueNumber = {
    previous: pres,
  }
  var date = Date.now()
  if (date <= uniqueNumber.previous) {
    date = ++uniqueNumber.previous
  } else {
    uniqueNumber.previous = date
  }

  return date
}

/**
 * 数字类型输入框禁止输入e
 * @param {*} e
 */
export function channelNumInput(e) {
  let key = e.key
  // 不允许输入'e'和'.'
  if (key === 'e' || key === '.') {
    e.returnValue = false
    return false
  }
  return true
}

/**
 * 深拷贝
 */
export function deepCopy(data) {
  return JSON.parse(JSON.stringify(data))
}

/**
 * 判断是否是闰年
 * @param {*}} date
 * @returns
 */
export function isLeapYear(date) {
  return 0 == date.getYear() % 4 && (date.getYear() % 100 != 0 || date.getYear() % 400 == 0)
}

/**
 * 获取date是月中第几天
 * @param {*} date
 * @returns
 */
export function getDaysInMonth(date) {
  var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  var m = date.getMonth()
  return m == 1 && isLeapYear(date) ? 29 : daysInMonth[m]
}

/**
 * 获取date所在月份的第一天。
 * @param {*} date
 * @returns
 */
export function getFirstDateOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

/**
 * 获取date所在月份的最后一天
 * @param {*} date
 * @returns
 */
export function getLastDateOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), getDaysInMonth(date))
}

/**
 * 获取date所在周
 * @param {*} date
 * @returns
 */
export function getWeekStrInWeek(date) {
  let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  let weekNum = date.getDay()
  return weekArr[weekNum]
}

/**
 * 获取date所在时间段 上午 下午
 * @param {*} date
 * @returns
 */
export function getTimeSlot(date) {
  let hours = date.getHours()
  let timeSlot = '上午'
  if (hours > 12) {
    timeSlot = '下午'
  }
  return timeSlot
}

/**
 * 日期add
 * @param {*} date 当前日期
 * @param {*} type 类型 day、month
 * @param {*} value 值
 * @returns
 */
export function addDate(date, type, value) {
  let d = new Date(date)
  switch (type) {
    case 'milli':
      d.setMilliseconds(d.getMilliseconds() + value)
      break
    case 'second':
      d.setSeconds(d.getSeconds() + value)
      break
    case 'minute':
      d.setMinutes(d.getMinutes() + value)
      break
    case 'hour':
      d.setHours(d.getHours() + value)
      break
    case 'day':
      d.setDate(d.getDate() + value)
      break
    case 'month':
      var day = d.getDate()
      if (day > 28) {
        let firstDate = getFirstDateOfMonth(d)
        firstDate = addDate(firstDate, 'month', value)
        firstDate = getLastDateOfMonth(firstDate)
        day = Math.min(day, firstDate.getDate())
      }
      d.setDate(day)
      d.setMonth(d.getMonth() + value)
      break
    case 'year':
      d.setFullYear(d.getFullYear() + value)
      break
  }
  return d
}

/**
 * 日期格式化
 * @param {*} val
 * @param {*} fmt
 * @returns
 */
export function formatDate(val, fmt) {
  if (!val) return ''
  let date = val
  if (typeof val == 'string') {
    date = new Date(Date.parse(val.replace(/-/g, '/').replace(/T/g, ' '))) // new Date(val)
  }
  if (typeof val == 'number') {
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}

///转为年月日
export function formatTimeToYMD(date, fmt) {
  date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}

/**
 *
 * @param {*} mss
 * @returns
 */
export function formatDuring(mss) {
  var minute = parseInt(mss / (1000 * 60))
  if (minute < 10) {
    minute = '0' + minute
  }
  var second = parseInt((mss % (1000 * 60)) / 1000)
  if (second < 10) {
    second = '0' + second
  }
  return minute + ':' + second
}

/**
 *
 * @param {*} mss
 * @returns
 */
export function formatDuringStr(mss) {
  var minute = parseInt(mss / (1000 * 60))
  if (minute < 10) {
    minute = '0' + minute
  }
  var second = parseInt((mss % (1000 * 60)) / 1000)
  if (second < 10) {
    second = '0' + second
  }
  // eslint-disable-next-line quotes
  return minute + "'" + second + "''"
}

/**
 *
 * @param {*} sec
 * @returns
 */
export function secondsFormatDuring(sec) {
  let minute = parseInt(parseInt(sec) / 60)
  if (minute < 10) {
    minute = '0' + minute
  }
  let second = parseInt(parseInt(sec) % 60)
  if (second < 10) {
    second = '0' + second
  }
  // eslint-disable-next-line quotes
  return minute + ':' + second
}

/**
 * 秒转时分秒
 * @param {*} sec
 * @returns
 */
export function secondsFormatHMS(sec) {
  let hour = parseInt(parseInt(sec) / 60 / 60)
  let minute = parseInt((parseInt(sec) / 60) % 60)
  if (hour < 10) {
    hour = '0' + hour
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  let second = parseInt(parseInt(sec) % 60)
  if (second < 10) {
    second = '0' + second
  }
  // eslint-disable-next-line quotes
  return hour + ':' + minute + ':' + second
}

/**
 * 时间转秒
 * @param {*} str
 * @returns
 */
export function TimeStrToSec(str) {
  let date = new Date().toLocaleDateString()
  str = date + ' ' + str
  date = new Date(str)
  let h = date.getHours()
  let m = date.getMinutes()
  let s = date.getSeconds()
  return h * 60 * 60 + m * 60 + s
}

/**
 * 是否是连续数组
 * @param {*} arr
 * @returns
 */
export function isContinuationArr(arr) {
  let i = arr[0]
  let isContinuation = true
  for (let e in arr) {
    if (arr[e] != i) {
      isContinuation = false
      break
    }
    i++
  }
  return isContinuation
}

/**
 *
 * @returns 是否是移动端
 */
export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  )
  return flag
}

//获取a中包含b的个数
export function getStrContainCount(a, b) {
  var reg = new RegExp(b, 'g')
  //利用match找出对应字符在中字符串中出现的地方，取匹配的返回数组的长度，即是对应字符串出现的次数
  return (a.match(reg) || []).length
}

/**
 * 分组
 * @param {*}} list
 * @param {*} key
 * @returns
 */
export function groupBy(list, key) {
  let groups = {}
  list.forEach(function(o) {
    let group = JSON.stringify(o[key])
    groups[group] = groups[group] || []
    groups[group].push(o)
  })
  return Object.keys(groups).map(function(group) {
    return groups[group]
  })
}

export function checkBrowser() {
  var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
  if (userAgent.indexOf('.NET CLR') > -1) {
    return false
  }

  return true
}

/**
 * 获取语言名称
 * @param {*} type
 */
export function getLanguageName(type) {
  let typeStr = ''
  switch (type) {
    case 1:
      typeStr = '中文'
      break
    case 2:
      typeStr = '英文'
      break
    case 3:
      typeStr = '日文'
      break
    case 4:
      typeStr = '韩文'
      break
    case 5:
      typeStr = '俄文'
      break
    case 6:
      typeStr = '法文'
      break
    case 10:
      typeStr = '德文'
      break
    case 7:
      typeStr = '西班牙'
      break
    case 8:
      typeStr = '中转英'
      break
    case 9:
      typeStr = '英转中'
      break
    case 11:
      typeStr = '中转俄'
      break
    case 12:
      typeStr = '俄转中'
      break
    case 13:
      typeStr = '中转德'
      break
    case 14:
      typeStr = '德转中'
      break
    case 15:
      typeStr = '中转日'
      break
    case 16:
      typeStr = '日转中'
      break
    case 17:
      typeStr = '中转韩'
      break
    case 18:
      typeStr = '韩转中'
      break
    case 19:
      typeStr = '中转法'
      break
    case 20:
      typeStr = '法转中'
      break
    case 21:
      typeStr = '中转西班牙'
      break
    case 22:
      typeStr = '西班牙转中'
      break
    default:
      typeStr = '中文'
      break
  }
  return typeStr
}

/**
 * 是否需要翻译
 * @param {*} languageType
 */
export function isTranslated(languageType) {
  let translated = false
  switch (languageType) {
    //8 中转英 9英转中
    case 8:
    case 9:
      translated = true
      break
  }
  return translated
}

/**
 * 获取文件类型
 * @param {*} suffix
 * @returns
 */
export function getFileType(suffix) {
  let type = 0
  switch (suffix.toLowerCase()) {
    case '.doc':
    case '.docx':
      type = 1
      break
    case '.xls':
    case '.xlsx':
      type = 2
      break
    case '.ppt':
    case '.pptx':
      type = 3
      break
    case '.pdf':
      type = 4
      break
    case '.jpg':
    case '.png':
    case '.gif':
    case '.jpeg':
      type = 5
      break
    case '.mp3':
      type = 6
      break
    case '.mp4':
    case '.flv':
      type = 7
      break
    case '.txt':
      type = 8
      break
    default:
      type = 8
      break
  }
  return type
}

export function getCookie(name) {
  var strcookie = document.cookie //获取cookie字符串
  var arrcookie = strcookie.split('; ') //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split('=')
    if (arr[0] == name) {
      return arr[1]
    }
  }
  return ''
}

/**
 * 设置cookie
 * @param {*} key
 * @param {*} value
 */
export function setCookie(key, value, day = 30) {
  var Days = day
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = key + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
}

/**
 * 删除cookie
 * @param {*} name
 */
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 10000)
  var cval = getCookie(name)
  if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString()
}

//获取与毫秒数的转化比例（相差天数：1，相差小时数：2，相差分钟数：3，相差秒数：4）
export function getDifferScale(value) {
  var format
  //获取转化比（天数跟毫秒数的比例）
  if (value == 1) {
    format = parseFloat(24 * 60 * 60 * 1000)
  }
  //获取转化比（小时数跟毫秒数的比例）
  else if (value == 2) {
    format = parseFloat(60 * 60 * 1000)
  }
  //获取转化比（分钟数跟毫秒数的比例）
  else if (value == 3) {
    format = parseFloat(60 * 1000)
  }
  //获取转化比（秒数跟毫秒数的比例）
  else if (value == 4) {
    format = parseFloat(1000)
  }
  return format
}

//获取两个日期的相差日期数(differ 相差天数：1、相差小时数：2、相差分钟数：3、相差秒数：4)
export function getDifferDate(firstDate, secondDate, differ) {
  //1)将两个日期字符串转化为日期对象
  var startDate = new Date(firstDate)
  var endDate = new Date(secondDate)
  //2)计算两个日期相差的毫秒数
  var msecNum = endDate.getTime() - startDate.getTime()
  //3)计算两个日期相差的天数
  var dayNum = Math.floor(msecNum / getDifferScale(differ))
  return dayNum
}

/**
 * 获取视频图片
 * @param {*} file
 * @param {*} id
 * @param {*} parentEleId
 * @param {*} call
 */
export function getVideoImage(file, id, parentEleId, call) {
  let videoList = document.getElementById(parentEleId)
  var video = document.createElement('video')
  video.id = id
  video.src = file
  video.setAttribute('crossOrigin', 'Anonymous')
  videoList.appendChild(video)
  video.addEventListener('loadeddata', function() {
    if (video.duration > 5) {
      video.currentTime = 5
    } else {
      video.currentTime = 1
    }
  })
  video.addEventListener('seeked', function() {
    let width = video.videoWidth
    let height = video.videoHeight
    let canvas = document.createElement('canvas')
    canvas.id = id + 'canvas'
    let ctx = canvas.getContext('2d')
    canvas.width = width
    canvas.height = height
    videoList.appendChild(canvas)
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
    let image = {
      url: canvas.toDataURL('image/jpeg', 1),
      width: this.width,
      height: this.height,
      currentTime: this.currentTime,
      duration: this.duration,
    }
    canvas.toBlob(function(blob) {
      image.blob = blob
      typeof call == 'function' ? call.call(file, image) : console.log(image)
    }, 'image/jpeg')
  })
}

/**
 * 是否为空值
 * @param {*} val
 */
export function isNullOrEmpty(val) {
  if (val == '' || val == null) {
    return true
  } else {
    return false
  }
}

/**
 * 输入字符检测
 * @param {*} name
 * @returns
 */
export function inputCharInspect(name) {
  let data = { msg: '', status: 1 }
  let reg = /(\\)|(\/)|(:)|(\*)|(\?)|(")|(')|(<)|(>)|(\|)|(\$)+/
  if (reg.test(name)) {
    data.msg = '不能包含:\\ / : * ? " \' < > | $'
    data.status = 0
    return data
  }
  return data
}

/**
 * 是否为Null
 * @param object
 * @returns {Boolean}
 */
export function isNull(object) {
  if (object == null || typeof object == 'undefined') {
    return true
  }
  return false
}

/**
 * 根据日期字符串获取星期几
 * @param dateString 日期字符串（如：2016-12-29），为空时为用户电脑当前日期
 * @returns {String}
 */
export function getWeekStr(dateString) {
  var date
  if (isNull(dateString)) {
    date = new Date()
  } else {
    var dateArray = dateString.split('-')
    date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2])
  }
  //var weeks = new Array("日", "一", "二", "三", "四", "五", "六");
  //return "星期" + weeks[date.getDay()];
  return '星期' + '日一二三四五六'.charAt(date.getDay())
}

/**
 * 输入检查
 * @param txt 检查的字符串
 * @returns {Boolean} true 检查通过
 */
export function inputCheck(txt) {
  let reg = /(\\)|(\/)|(:)|(\*)|(\?)|(")|(')|(<)|(>)|(\|)|(\$)+/
  if (reg.test(txt)) {
    return false
  }
  return true
}

export function replaceDoMain(url) {
  // 'http://192.168.1.238/StorageRootB/VideoResourceCover/1234567899876543211/20220223045413914426.png'
  var patt = new RegExp('https?://')
  //去除https?://
  let str = url.replace(patt, '')
  var patt1 = new RegExp('(?=/).*')
  let str2 = str.match(patt1)
  //匹配得到 '/StorageRootB/VideoResourceCover/1234567899876543211/20220223045413914426.png'
  if (str2.length > 0) {
    return `/fileProxy${str2[0]}`
  }
  return url
}
export function removeDoMain(url) {
  // 'http://192.168.1.238/StorageRootB/VideoResourceCover/1234567899876543211/20220223045413914426.png'
  var patt = new RegExp('https?://')
  //去除https?://
  let str = url.replace(patt, '')
  var patt1 = new RegExp('(?=/).*')
  let str2 = str.match(patt1)
  //匹配得到 '/StorageRootB/VideoResourceCover/1234567899876543211/20220223045413914426.png'
  if (str2.length > 0) {
    return str2[0]
  }
  return url
}

//获取资源正确url
export function getResourceCorrectUrl(url) {
  let patt = new RegExp('https?://')
  const existStr = patt.test(url)
  if (existStr) {
    return url
  }
  //判断url前缀是否是/或//
  patt = new RegExp('^/{1,2}')
  if (patt.test(url)) {
    return url
  }
  return '/' + url
}

//拼接url 去除参数1尾部/ // 以及参数2头部/ //
export function spliceUrl(param1, param2) {
  const startPatt = new RegExp('^/{1,2}')
  const endPart = new RegExp('/{1,2}$')
  return `${param1.replace(endPart, '')}/${param2.replace(startPatt, '')}`
}

/**
 * 去除最后的回车
 * @param {*} param
 * @returns
 */
export function removeLastEnter(param) {
  const removeLastEnterPatt = new RegExp('\\n$')
  return param.replace(removeLastEnterPatt, '')
}

export const imgCheck = async (url, checkFun, crossOrigin = 'anonymous') => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const c = document.createElement('canvas')

      c.width = img.naturalWidth
      c.height = img.naturalHeight

      const cxt = c.getContext('2d')

      cxt.drawImage(img, 0, 0)
      // 得到图片的base64编码数据
      // resolve(c.toDataURL('image/png'));
      resolve(checkFun(img))
    }

    crossOrigin && img.setAttribute('crossOrigin', crossOrigin)
    img.src = url
  })
}

/**
 * 扁平化处理
 * @param {*} data
 * @returns
 */
export function treeFlat(data = []) {
  return [].concat(...data.map((item) => [].concat(item, ...treeFlat(item.children))))
}

export function getWeekStrByWeek(week) {
  let weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
  return weekArr[week]
}

/**
 * 数字相加
 * @param {*} a
 * @param {*} b
 * @returns
 */
export function numberAdd(a, b) {
  let c = Math.max(getDecimalLength(a), getDecimalLength(b))
  let d = Math.pow(10, c)
  return (a * d + b * d) / d
}

/**
 * 获取小数点后的位数
 * @param {*} num
 * @returns
 */
function getDecimalLength(num) {
  var str = num.toString()
  if (str.indexOf('.') !== -1) {
    return str.length - str.indexOf('.') - 1
  }
  return 0
}

/**
 * 下载
 * @param  {String} fileUrl 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export function downloadFileRename(fileUrl) {
  // 在新页面中打开链接
  const newWindow = window.open(fileUrl, '_blank')
  // 等待新页面加载完成后执行下载操作
  newWindow.onload = function() {
    // 创建一个<a>标签
    const link = newWindow.document.createElement('a')
    // 设置<a>标签的href属性为文件URL
    link.href = fileUrl
    // 设置下载的文件名
    link.download = 'rename_file'
    // 将<a>标签添加到新页面中
    newWindow.document.body.appendChild(link)
    // 模拟点击<a>标签
    link.click()
    // 移除<a>标签
    newWindow.document.body.removeChild(link)
  }
}
